import { render, staticRenderFns } from "./btn-hamburger.vue?vue&type=template&id=36fb5712&scoped=true&"
import script from "./btn-hamburger.vue?vue&type=script&lang=js&"
export * from "./btn-hamburger.vue?vue&type=script&lang=js&"
import style0 from "./btn-hamburger.vue?vue&type=style&index=0&id=36fb5712&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fb5712",
  null
  
)

export default component.exports